
class colorSwatches extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.init();
      this.insertAdjacentHTML('beforeend', "<div></div>")
    }
  
    init() {
      this.variantSwatches = this.querySelectorAll("[js-variant-swatch]");
      this.variantSwatches.forEach( el => el.addEventListener("mouseenter", this.handleSwatch.bind(this)))
    }

    handleSwatch({ currentTarget }) {
      const productCard = currentTarget.closest("[js-product-card]");
      const quickViewButton = productCard.querySelector(".quick-add__submit");
      const priceCompareElement = productCard.querySelector("[js-compare-price]");
      const priceElement = productCard.querySelector("[js-price]");
      const salePriceElement = productCard.querySelector("[js-sale-price]");
      const currentProductHandle = quickViewButton.getAttribute("data-product-handle");
      const currentVariantID = currentTarget.getAttribute("data-variant-id");
      const currentVariantPrice = currentTarget.getAttribute("data-variant-price");
      const currentVariantComparePrice = currentTarget.getAttribute("data-variant-compare-price");
      const primaryImage = productCard.querySelector('[js-product-image]');
      const productLink = productCard.querySelector('[js-product-variant-url]');
      priceElement.textContent = "Shop — " + currentVariantPrice;
      salePriceElement.textContent = currentVariantPrice;
      priceCompareElement.textContent = currentVariantComparePrice;

      if(currentVariantComparePrice) {
        currentTarget.closest('.card__content').querySelector('.price__regular').style.display = 'none';
        currentTarget.closest('.card__content').querySelector('.price__sale').style.display = 'block';
      } else {
        currentTarget.closest('.card__content').querySelector('.price__sale').style.display = 'none';
        currentTarget.closest('.card__content').querySelector('.price__regular').style.display = 'block';
      }

      const newProductUrl = `/products/${currentProductHandle}?variant=${currentVariantID}`;
      quickViewButton.setAttribute("data-product-url", newProductUrl);
     productLink.href = newProductUrl;

      this.variantSwatches.forEach(function (color) {
        color.parentElement.classList.remove('selected');
      });
      currentTarget.parentElement.classList.add('selected');
      const primaryImageUrl = currentTarget.getAttribute('data-primary-image-src');

      if (primaryImageUrl) {
        primaryImage.setAttribute('srcset', primaryImageUrl);
        primaryImage.setAttribute('src', primaryImageUrl);
      }
    }
  }
    
  customElements.define('color-swatches', colorSwatches);